// @flow
import React from 'react';
import styled from 'styled-components';
import { Spin } from '../';

export const StyledPreloader = styled.div`
	position: fixed;
	z-index: 999999;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: rgba(4, 4, 4, 0.72);

`;

export const Preloader = () => (
	<StyledPreloader>
		<Spin />
	</StyledPreloader>
);

export default Preloader;


// WEBPACK FOOTER //
// ./src/components/Preloader/index.js